<template>
	<div>
		<p
			class="text-smaller pb-4"
		>{{$t('Üdvözöljük a BKK Telebusz oldalán. Járat igénylés rögzítéséhez jelentkezzen be az alkalmazásba, vagy amennyiben új látogatónk, kérjük regisztráljon!')}}</p>

		<form @submit.prevent="submit()">
			<div class="form-group form-group--with-icon">
                <label for="email" class="d-none">{{$t('E-mail cím')}}</label>
				<input
					v-model="LoginVM.email"
					v-input-class
					type="email"
					name="email"
                    id="email"
					class="input"
					:placeholder="$t('E-mail cím')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/email.svg" :alt="$t('E-mail cím')" />
				</span>
			</div>

			<div class="form-group form-group--password form-group--with-icon pb-4">
                <label for="password" class="d-none">{{$t('Jelszó')}}</label>
				<input
					v-model="LoginVM.password"
					v-input-class
					:type="showPassword? 'text' : 'password'"
                    id="password"
					name="password"
					class="input"
					:placeholder="$t('Jelszó')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/lock.svg" :alt="$t('Jelszó')" />
				</span>
				<button
					type="button"
                    aria-label="Jelszó megtekintése"
					@click.prevent.stop="showPassword = !showPassword"
					class="input__show-password"
				>
                    <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
				</button>
			</div>

			<div class="pb-4">
				<button :disabled="!this.LoginVM.email || !this.LoginVM.password ? 'disabled':false" type="submit" class="button w-100">{{$t('Belépés')}}</button>
			</div>
		</form>

		<div class="pb-4 text-smaller color-grey3">
			{{$t('Még nincs fiókja?')}}
			<router-link class="link-dark" :to="regLink">{{ $t('Regisztráljon!') }}</router-link>
		</div>

		<div class="text-smaller">
			<router-link class="link-dark" :to="{name: 'forgotten-password'}">{{ $t('Elfelejtettem a jelszavam') }}</router-link>
		</div>
	</div>
</template>

<script>
import { authorizeUsingPOST } from "@/api.js";

import { LoginVM } from "@/models" 

export default {
	name: "Login",
	data() {
		return {
            LoginVM: new LoginVM(),
			submitted: false,
			showPassword: false
		};
	},
    computed: {
        regLink: function() {
            if(this.$route.query.redirect) {
                return {name: 'registration', query: {redirect: this.$route.query.redirect}}
            } else {
                return {name: 'registration'}
            }
        }
    },
	methods: {
		submit: function () {
			this.submitted = true;

			if (!this.LoginVM.email || !this.LoginVM.password) return false;

			authorizeUsingPOST({ loginVm: this.LoginVM })
				.then((response) => {
					if (response.status === 200) {
                        this.$store.commit('loggedIn', response.data.id_token);
                        this.$router.push(this.$route.query.redirect || {name: 'demand-request'})
					}
				})
				.catch((err) => {
                    if(err.status === 401) {
                        return this.$swal({
                            title: this.$t("Bejelentkezés"),
                            text: this.$t("Rossz felhasználónév vagy jelszó!"),
                            imageUrl: window.swalError,
                        });
                    }
                    this.$swal({
                            title: this.$t("Bejelentkezés"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
				});
		},
	},
};
</script>

<style lang="scss">
.input__show-password {
    .svg-fill {
        fill: #333333;
    }
}
    
</style>